<div class="layout-wrapper">
  <div
    #layoutContainer
    class="layout-container"
    [ngClass]="{
      'menu-layout-static': !isOverlay(),
      'menu-layout-overlay': isOverlay(),
      'layout-menu-overlay-active': overlayMenuActive,
      'menu-layout-horizontal': isHorizontal(),
      'menu-layout-slim': isSlim(),
      'layout-menu-static-inactive': staticMenuDesktopInactive,
      'layout-menu-static-active': staticMenuMobileActive
    }"
    >
    <app-toolbar></app-toolbar>
    <div
      class="layout-menu"
      [ngClass]="{ 'layout-menu-dark': darkMenu }"
      (click)="onMenuClick($event)"
      >
      <p-scrollPanel #scrollPanel [style]="{ height: '100%' }">
        @if (profileMode === 'inline' && !isHorizontal()) {
          <app-profile
          ></app-profile>
        }
        <app-menu [reset]="resetMenu"></app-menu>
      </p-scrollPanel>
    </div>

    <div class="layout-main">
      <app-breadcrumb></app-breadcrumb>
      <app-layout-notificacao-vencimento></app-layout-notificacao-vencimento>
      <div class="layout-content">
        <router-outlet> </router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>

<p-toast></p-toast>
<p-toast key="msg-error"></p-toast>
<p-toast key="msg-error-dialog"></p-toast>

<p-confirmDialog
  [style]="{ width: '280px' }"
  header="Confirmação"
  aria-label="dialog-confimar"
  icon="pi pi-question-circle"
  #confirmacao
  >
  <ng-template pTemplate="footer">
    <div class="p-d-flex p-justify-around">
      <p-button type="button" aria-label="btn-confirmar-sim" icon="pi pi-check" label="Sim" (onClick)="confirmacao.onAccept()"></p-button>
      <p-button type="button" aria-label="btn-confirmar-nao" icon="pi pi-times" label="Não" (onClick)="confirmacao.onReject()" variant="text" severity="secondary" autofocus></p-button>
    </div>
  </ng-template>
</p-confirmDialog>
<app-loading></app-loading>
